class DZModelContacts{
    
    /**
     * 主键
     */
    id = "";
    
    /**
     * 身份：0-普通用户，1-代理商
     */
    type = "";

    /**
     * 联系人姓名
     */
    contactsName = "";

    /**
     * 联系人电话
     */
    contactsPhone = "";

    /**
     * 备用电话
     */
    contactsPhoneOther = "";

    /**
     * 更新用户ID
     */
    updateBy = "";

    /**
     * 更新时间
     */
    updateTime = "";

    /**
     * 发布用户ID
     */
    createBy = "";

    /**
     * 创建时间
     */
    createTime = "";
}
export default DZModelContacts